import { Component } from '@theme/component';
import { ThemeEvents }from '@theme/events';
import { morph } from '@theme/morph';


export class TemplateDesignPreview extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.onVariantUpdate = this.onVariantUpdate.bind(this);

    document.addEventListener(
      ThemeEvents.variantUpdate,
      this.onVariantUpdate
    );
  }

  disconnectedCallback() {
    document.removeEventListener(
      ThemeEvents.variantUpdate,
      this.onVariantUpdate
    );
  }

  /**
   * Kein private field → maximale Browser-Kompatibilität
   * @param {CustomEvent} event
   */
  onVariantUpdate(event) {
    const html = event.detail?.data?.html;
    if (!html) return;

    this.render(html);
  }

render(html) {
  const newContent = html.getElementById(this.id);
  if (!newContent) return;

  morph(this, newContent);

  // Render child previews after DOM update
  queueMicrotask(() => {
    requestAnimationFrame(() => {
      this.querySelectorAll('design-image-preview')
        .forEach(el => el.render?.());
    });
  });
}
}

if (!customElements.get('template-design-preview')) {
  customElements.define(
    'template-design-preview',
    TemplateDesignPreview
  );
}


/**
 * <design-image-preview>
 *
 * Füllt automatisch Empfänger & Nachricht in der Design-Vorschau.
 */
export class DesignImagePreview extends Component {
  /** @type {Component | null} */
  recipientForm = null;

  connectedCallback() {
    super.connectedCallback();
    this.recipientForm =
      this.closest('form')?.querySelector('gift-card-recipient-form') ?? null;

    this.render = this.render.bind(this);

    this.render();

    this.recipientForm?.addEventListener('input', this.render);
  }

  disconnectedCallback() {
    this.recipientForm?.removeEventListener('input', this.render);
  }

  /**
   * Rendert Empfänger & Nachricht in die Preview
   */
  render() {
    const { recipient, message } = this.refs;

    if (!this.recipientForm || !this.recipientForm.refs) return;

    // ---- RECIPIENT ----
    if (recipient instanceof HTMLElement) {
      const recipientInput = this.recipientForm.refs.recipientName;

      if (recipientInput instanceof HTMLInputElement) {
        recipient.textContent = recipientInput.value || '';
      }
    }

    // ---- MESSAGE ----
    if (message instanceof HTMLElement) {
      const messageInput = this.recipientForm.refs.recipientMessage;

      if (messageInput instanceof HTMLTextAreaElement) {
        message.textContent =
          messageInput.value || '';
      } else {
        message.textContent = '';
      }
    }
  }
}

if (!customElements.get('design-image-preview')) {
  customElements.define(
    'design-image-preview',
    DesignImagePreview
  );
}
